<template>
  <LayoutDefault>
    <UnlockPostWithTokensModal v-if="openModalUnlockPost" @cancel="openModalUnlockPost = !openModalUnlockPost" :model="unlockPostModel" :post="unlockPostPost"/>
    <div
        v-if="model /*&& model.webstar*/"
        id="webstar_profile"
        class="container"
    >
      <div
          class="banner"
          :style="{backgroundImage: `url('${public_banner_image_path}')`}"
      >
      </div>
      <div class="data">
        <div class="profile">
          <router-link
            :to="{name: 'model.username', params: {username: '@' + model.username}}"
          >
            <div class="pic"
                  :style="{backgroundImage: `url('${public_profile_image_path}')`}"
            ></div>
          </router-link>
          <div class="name">
            <router-link
                :to="{name: 'model.username', params: {username: '@' + model.username}}"
            >
              {{model.name}}
            </router-link>
            <div
                v-if="model.username"
                class="username"
            >
              <router-link
                :to="{name: 'model.username', params: {username: '@' + model.username}}"
              >
                @{{ model.username }}
              </router-link>
              <img
                v-if="model.verified"
                class="badge-verified"
                src="/img/verified.png"
                alt="verified"
                title="verified"
              >
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="subscribe-actions" style="display: flex; flex-direction: column;" v-if="true">
            <ButtonChatWithModel
              class="btn_follow"
              :model="model"
              v-if="chatButtonEnabled"
            />
            <ButtonReport class="btn_follow" :model="model" v-if="reportButtonEnabled"/>
            <div class="btn_ghost" v-for="(index) in BTN_GHOST_ARRAY" :key="index">
              <div></div>
            </div>
          </div>
          <div class="about-me">
            {{ wrappedText }}<template v-if="wrapTextMore">
              {{ wrappedTextMore }}
            </template><template v-else-if="wrapText">...</template>

            <span id="wrap-text" v-if="wrapText" @click="wrapTextMore = !wrapTextMore">{{ wrapTextMore ? $t("single_text.readLess") : $t("single_text.readMore") }}</span>

            <!--
            <div
              v-for="(social, index ) in model.public_socials"
              :key="index"
              class="social-buttons"
            >
              <a :href="social.url" target="_blank">
                <img :src="`/img/socials/${social.site}.png`" :alt="social.site">
                @{{social.user}}
              </a>
            </div> -->
          </div>
        </div>
        <SubscriptionPackSection
          v-if="subscriptionsEnabled"
          :subscription_plans="model.subscription_plans.data"
        />
      </div>
    </div>

    <div
        id="model_profile"
        class="container"
    >
      <template v-if="!loadingModel && !errorModel">
        <div class="model-wrapper">
          <!-- <h3
              v-if="!model.webstar"
              class="title">
              {{model.name}}
          </h3> -->

          <div class="video-wrapper"></div>

          <div class="model-video-list">
<!--            <h4 class="title">-->
<!--              {{$t('model_profile.videos_im_in')}}-->
<!--            </h4>-->
            <ResourceScroller
                    :v-if="modelMoviesScroller !== null"
                    :resource="modelMoviesScroller.resource"
                    :default-params="modelMoviesScroller.defaultParams"
                    :viewMode="viewMode"
                    :per-page="10"
                    @changeViewMode="changeViewMode"
            >
              <template slot-scope="{element, changeViewMode}">
                <PostSorter 
                  :element="element" 
                  :model="model" 
                  :viewMode="viewMode" 
                  :changeViewMode="changeViewMode"
                  :showChat="chatButtonEnabled"
                />
              </template>
              <template slot="placeholder" slot-scope="data">
                <MovieBlockedContainer :placeholder="true"/>
              </template>
              <template slot="loading">
                <Spinner></Spinner>
              </template>
            </ResourceScroller>
          </div>
        </div>
      </template>

      <template v-else>
        <div v-if="loadingModel" class="loading-model">
          <Spinner></Spinner>
        </div>
        <div v-if="errorModel" class="error-model">
            {{$t('error')}}
        </div>
      </template>
    </div>
  </LayoutDefault>
</template>

<script>
import Spinner from "../../components/Spinner";
import resources from '../../resources';
import ResourceScroller from "../../components/V2/ResourceScroller";
import MovieBlockedContainer from "../../components/Post/Movie/BlockedContainer.vue";
import EventBus from '../../eventbus';
import LayoutDefault from "../../layouts/LayoutDefault";
import FollowModelButton from "../../components/CallToAction/ButtonFollowModel";
import ButtonChatWithModel from "../../components/CallToAction/ButtonChatWithModel";
import PostSorter from "../../components/Post/Sorter";
import UnlockPostWithTokensModal from "../../components/UnlockPostWithTokensModal"
import ButtonReport from "../../components/CallToAction/ButtonReport.vue";
import SubscriptionPackSection from "../../components/CallToAction/SubscriptionPackSection.vue";

import ThemeManager from '../../modules/ThemeManager/ThemeManager';

export default {
    components: {
    PostSorter,
    LayoutDefault,
    Spinner,
    ResourceScroller,
    MovieBlockedContainer,
    FollowModelButton,
    ButtonChatWithModel,
    UnlockPostWithTokensModal,
    ButtonReport,
    SubscriptionPackSection
    },
    data(){
      return {
          model: null,
          loadingModel: true,
          loadingChat: true,
          errorModel: false,
          languageChanged: false,
          openModalUnlockPost: false,
          unlockPostModel: {},
          unlockPostPost: {},
          wrapText: false,
          wrapTextMore: false,
          wrappedText: "",
          wrappedTextMore: "",
          // viewMode: 'grid'
          viewMode: 'vertical',
          MAX_TEXT_LENGTH: 128,
      }
    },
    methods: {
        loadModel(id){
            this.loadingModel = true;
            this.errorModel = false;
            this.model = null;

            const isChatEnabled = !! (process.env.VUE_APP_CHAT_ENABLED && process.env.VUE_APP_CHAT_ENABLED === 'true'); 

            let data = { id: id };
            if(this.$route.params.username){
              data.username = id;
            }
            
            if(this.$i18n && this.$i18n.locale){
              data.lang = this.$i18n.locale;
            }
  
          data.include = ['subscription_plans'];
            
            resources.models.get(data)
                .then(response => {
                  this.loadingChat = true;
                  this.loadingModel = false;
                  this.model = response.data.data;

                  if(response.data.data.length === 0){
                    //If the language didn't change, and the model doesnt exist redirect to 404.
                    if(this.languageChanged==false) this.$router.push({name: 'error404'});
                    else this.languageChanged = false;
                  } else if (this.model.id) {                    
                    data.id = this.model.id;

                    if(isChatEnabled){
                        resources.chatModel.apiReadPost(data).then((response) => {
                        this.loadingChat = false;
                        this.model.chat = response.data.data;
                      }).catch((error) => {
                        this.loadingChat = true;
                      });
                    }

                    const sex = this.model.sex;
                    ThemeManager.changeBySex(sex);

                  }

                  if (this.hideMenuItemsOfModel) {
                    this.MAX_TEXT_LENGTH = 512;
                  }

                }).catch(err => {
                    this.loadingModel = false;
                    this.errorModel = true;
                });
        },
        changeViewMode(id){
          this.viewMode = this.viewMode === 'grid' ? 'vertical' : 'grid';

          setTimeout(() => {
            document.getElementById(id).scrollIntoView({behavior: "smooth"});
          }, 200);

        }
    },
    mounted(){
        let model = (this.$route.params.username) ? this.$route.params.username : this.$route.params.id;
        this.loadModel(model);

        EventBus.$on('languageChanged', () => {
            this.languageChanged = true;
            this.loadModel(model);
        });

        EventBus.$on('openedUnlockPostWithTokens', (post, model) => {
          this.unlockPostPost = post;
          this.unlockPostModel = model;
          this.openModalUnlockPost = true;
        });
    },
    beforeRouteUpdate (to, from, next) {
      if (to.name === 'model.username') {
        const { username, id } = to.params;
        const model = (username) ? username : id;
        this.loadModel(model);
      }

        next();
    },
    computed: {
        similarModelsScroller(){
            if(this.loadingModel || this.errorModel){
                return null;
            }

            return {
                resource: resources.models,
                defaultParams: {
                    include: [],
                    models: {
                        id: this.model.id
                    }
                },
            };
        },
        modelMoviesScroller(){
            if(this.loadingModel || this.errorModel){
                return null;
            }

            return {
                resource: resources.posts,
                defaultParams: {
                    include: [],
                    models: {
                        id: this.model.id
                    }
                },
            };
        },
        subscriptionPlanPremium(){
            if(this.loadingModel || this.errorModel || !this.model.subscription_plans){
                return null;
            }

            return this.model.subscription_plans.data.find(subscription_plan => subscription_plan.premium)
        },
        hideMenuItemsOfModel(){
          let listOfModels = process.env.VUE_APP_HIDE_MENU_USERS;

          if (!listOfModels) return false;

          listOfModels = listOfModels.split(',');

          return listOfModels.includes(this.model.username);
        },
        chatButtonEnabled() {
          let chatEnabled = process.env.VUE_APP_CHAT_ENABLED;
          chatEnabled = (chatEnabled && chatEnabled === 'true' && !this.hideMenuItemsOfModel);

          return chatEnabled && this.model && this.model.chat_enabled;
        },
        reportButtonEnabled() {
          return !this.hideMenuItemsOfModel;
        },
        subscriptionsEnabled() {
          return !this.hideMenuItemsOfModel && this.model && this.model.subscription_plans;
        },
        BTN_GHOST_ARRAY(){
          let q = 0;

          q += !this.chatButtonEnabled;
          q += !this.reportButtonEnabled;

          return new Array(q);
        },
        public_banner_image_path(){
          return ThemeManager.parseWebstarDefaultsImageUrl(this.model.public_banner_image_path);
        },
        public_profile_image_path(){
          return ThemeManager.parseWebstarDefaultsImageUrl(this.model.public_profile_image_path);
        }
    },
    watch: {
      'model.about_me': function (val) {
        if (!val) {
          this.wrapText = false;
          this.wrappedText = "";
          this.wrappedTextMore = "";
          return;
        }

        if (val.length > this.MAX_TEXT_LENGTH * 1.25) {
          this.wrapText = true;
          this.wrappedText = val.substring(0, this.MAX_TEXT_LENGTH);
          this.wrappedTextMore = val.substring(this.MAX_TEXT_LENGTH, val.length);

          let i = this.MAX_TEXT_LENGTH - 1;
          while (this.wrappedText[i--] === " ") {
            this.wrappedText = this.wrappedText.substring(0, this.wrappedText.length - 1);
            this.wrappedTextMore = " " + this.wrappedTextMore;
          }
        } else {
          this.wrapText = false;
          this.wrappedText = val;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';
  @import "../../styles/classes";

  #model_profile{
    background-color: var(--pallete_clear_color);
    padding: 30px 7px;

    .model-wrapper{
      display: block;
      margin: auto;
      max-width: 100%;

      .about{
        display: block;
        margin: auto;
        width: 70%;

        @media(max-width: 768px){
          width: 100%;
        }
      }

      & > .title {
          border-top: 10px solid var(--pallete_main_color);
          color: #000000;
          padding: .33em;
          font-size: 1.4em;
          text-align: left;
          margin: 0;
          text-transform: uppercase;
          display: inline-block;
      }

      .image{
        /*
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            background-color: lightgrey;
        */

        min-height: 250px;
        max-width: 100%;
        height: auto;

        img{
            width: auto;
            display: block;
            margin: auto;
            height: auto;
            max-height: 100vh;
        }
      }

      .title{
        text-align: left;
        margin: 0;
        margin-bottom: 10px;
      }

      .banner{
        display: block;
        margin: auto;
        width: auto;
        max-height: 500px;
      }

      .details{
        .title{
          font-size: 40px;
          text-transform: uppercase;
          color: var(--pallete_main_color);
          margin: 0 0 20px 0;
        }
      }

    }

    .model-video-list{
      margin-bottom: 75px;
      // margin-top: 35px;

      .title{
        font-size: 1.4em;
        text-align: left;
        margin: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
      }
    }

    .related-models{

      .title{
        font-size: 1.4em;
        text-align: left;
        margin: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
      }


    }
  }
</style>
<style lang="scss">
  #model_profile{
    .related-models {
      .model {
        width: 250px;

        .img {
          height: 420px;
        }
      }
    }

    // tamaño del video
    .model-video-list{
    }
  }
</style>

<style scoped lang="scss">
@import '../../styles/variables';

#webstar_profile {
  .banner{
    position: relative;
    height: 350px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    @media(max-width: 768px){
      height: 200px;
    }
  }

  .data{
    position: relative;
    min-height: 150px;
    background: var(--pallete_clear_color);
    @media(max-width: 768px){
      height: unset;
    }

    .profile{
      width: 40%;
      min-height: 250px;
      position: absolute;
      left: 5px;
      top: -100px;
      @media(max-width: 768px){
        position: relative;
        width: 99%;
        min-height: unset;
      }
      .pic{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-color: #ffffff;
        border-radius: 50%;
        border: 3px solid #ffffff;

        @media(max-width: 768px){
          width: 150px;
          height: 150px;
        }
      }
      .name{
        min-height: 50px;
        font-size: 1.5em;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 10px;
        @media(max-width: 768px){
          min-height: unset;
        }

        .username{
          display: flex;
          justify-content: center;
          font-size: .6em;
          text-transform: initial;
          margin: 3px;
          color: #7986cb;
          &:hover{
            color: #5768c4;
          }
          
          img{
            &.badge-verified{
            width: 20px;
            height: 20px;
            margin-left: 5px;
            margin-block: auto;
            }
          }
        }
      }
    }

    .right-container{
      // position: absolute;
      // right: 10px;
      // top: 10px;

      display: flex;

      width: 65%;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;

      padding: 10px 10px 20px 0;
      margin-left: auto;

      .btn_follow.last-of-group{
        margin-bottom: 40px;
      }
      .btn_follow, .btn_ghost {
        margin-bottom: 7px;
      }

      .btn_ghost {
        @media(max-width: 768px){
          margin-bottom: 0;
        }

        > div {
          min-height: 50px;
          display: flex;
          margin-bottom: 5px;

          @media(max-width: 768px){
            display: none;
            margin-bottom: 0;
          }
        }
      }

      .about-me{
        margin-right: 20px;
        @media(max-width: 768px){
          margin: 10px auto 25px auto;
        }
  
        .social-buttons{
          margin: 10px 0;
          
          a{
            display: flex;
            align-items: center;
            font-size: .8em;
  
            @media(max-width: 768px){
              justify-content: center;
            }
            
            img{
              width: 20px;
              margin-right: 5px;
            }
          }
        }
      }

      @media(max-width: 768px){
        position: relative;
        width: 95%;
        text-align: center;
        right: 0;
        left: 0;
        top: unset;
        bottom: 0;
        margin: 0 auto;
        flex-direction: column-reverse;
        align-items: center;
        margin-top: -100px;
      }
    }
  }
}

#wrap-text {
  color: #7986cb;
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
}

</style>
